import React from 'react';
import {string, bool, object, func, arrayOf, number, any} from 'prop-types';
import partial from 'lodash/partial';
import isEmpty from 'lodash/isEmpty';
import ImageEditForm from './ImageEditForm.jsx';
import imageInfoValidator from 'hoc/imageInfoValidator';
import BasicModal from "components/common/BasicModal";
import {EmptyFunc} from 'utils/DBUtils';
import imageEditConfig from './imageFormConfig';

const ImageEditModal = props => {
  const inFlight = props.uploadingImage || props.editingImage;
  return (
    <BasicModal
      open={props.isOpen}
      header="Image Information"
      keepModalOnTop={true}
      specialType="primary-modal"
      onClose={props.onClose}
      actions={[
        {
          label: "Cancel",
          isDisabled: inFlight,
          displayType: "menu-item",
          action: props.onClose
        },
        {
          label: props.submitButtonText,
          isDisabled: inFlight,
          loading: inFlight,
          displayType: "button",
          primaryCheck: true,
          action: partial(props.onSaveData, props.data)
        }
      ]}>
      {isEmpty(props.data) ? <p>Loading</p> : (
        <ImageEditForm
          formData={props.data}
          onSaveData={props.onSaveData}
          uploadingImage={props.uploadingImage}
          editingImage={props.editingImage}
          carouselSettings={props.carouselSettings}
          enableBulkUpload={props.enableBulkUpload}
          pendingImages={props.pendingImages}
          selectedIndex={props.selectedPendingImageIndex}
          selectedImageSiblings={props.selectedImageSiblings}
          siblingClicked={props.siblingClicked}
          errors={props.showErrors ? props.errors : {}}
          onValidationError={console.log}
          onValueChanged={props.onValueChanged} />)}
    </BasicModal>
  );
};

ImageEditModal.propTypes = {
  enableBulkUpload: bool,
  selectedImage: object,
  isOpen: bool.isRequired,
  submitButtonText: string,
  onSaveData: func.isRequired,
  onClose: func.isRequired,
  uploadingImage: bool,
  editingImage: bool,
  pendingImages: arrayOf(object),
  selectedPendingImageIndex: number,
  selectedImageSiblings: arrayOf(object),
  siblingClicked: func,
  onValidationError: func,
  onValueChanged: func,
  data: any
};

ImageEditModal.defaultProps = {
  submitButtonText: 'Save'
};

export default imageInfoValidator(ImageEditModal);



// WEBPACK FOOTER //
// ./public/components/images/ImageEditModal.jsx